import { render, staticRenderFns } from "./LicitacaoAtualizacaoAcoesPublicar.vue?vue&type=template&id=76d6d01c"
import script from "./LicitacaoAtualizacaoAcoesPublicar.vue?vue&type=script&lang=js"
export * from "./LicitacaoAtualizacaoAcoesPublicar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports